// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___T8O_N";